import { Permissions } from 'models/permissions';
import { User } from 'models/user';

export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_PERMISSION = 'SET_USER_PERMISSION';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const CREATE_USER = 'CREATE_USER';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';

interface GetUserInfo {
  type: typeof SET_USER_INFO;
  payload: { user: User };
}

interface GetUsers {
  type: typeof GET_USERS | typeof SET_USERS;
  payload: { users: Array<User> };
}

interface CreateUser {
  type: typeof GET_USERS | typeof SET_USERS;
  payload?: { users: Array<User> };
}

interface EditUser {
  type: typeof GET_USERS | typeof SET_USERS;
  payload?: { users: Array<User> };
}

interface DeleteUser {
  type: typeof GET_USERS | typeof SET_USERS;
  payload?: { users: Array<User> };
}

interface SetUserPermission {
  type: typeof SET_USER_PERMISSION;
  payload: { permissions?: Permissions };
}

export type UserActions =
  | GetUserInfo
  | GetUsers
  | CreateUser
  | EditUser
  | DeleteUser
  | SetUserPermission;
